




























































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import {
  QrAlipayBox,
  CheckUser,
  UserGames,
  ServerList,
  RoleList,
  PayGrade,
  QrAlipayGame,
  QrWechatGame,
} from "@/req/pay";
@Component
export default class Logout extends Vue {
  @Prop({
    default() {
      return [];
    },
    type: Array,
  })
  public payList;
  public payListData = [];
  public QRCode: any;
  public active: any = null;
  public money: any = ""; // 展示的支付金额
  public moneyChange: any = ""; // 输入的支付金额
  public activeWay: any = null;
  public imglogo = require("@/assets/icons/Alipay.png"); // 支付宝icon
  public imglogoWX = require("@/assets/icons/WehcatPay.png"); // 微信icon
  public account = ""; // 当前输入账号
  public lastAccount = ""; // 上次输入账号
  public payWay = [
    {
      game_id: 1,
      name: "支付宝",
    },
    {
      game_id: 2,
      name: "微信",
    },
    {
      game_id: 3,
      name: "账户余额",
    },
    {
      game_id: 4,
      name: "金币",
    },
  ];
  // 游戏选区
  public gameList = [];
  public boxGameId = "";
  // 区服列表
  public serverList = [];
  public serverid = "";
  public timer: any = null; // 定时器名称
  // 选择角色
  public roleList = [];
  public roleid: any = null;
  @Watch("money")
  @Watch("activeWay")
  @Watch("roleid")
  public async idsChange(val) {
    clearTimeout(this.timer);
    this.timer = null;
    if (this.money != null && this.activeWay != null && this.roleid != null) {
      this.qrScan();
    }
  }
  public async qrScan() {
    clearTimeout(this.timer);
    this.timer = null;
    const obj = {
      uid: this.$store.state.user.formInline.id,
      pay_amount: this.money * 100,
      box_game_id: this.boxGameId,
      serverid: this.serverid,
      roleid: this.roleid,
      extend: "",
    };
    if (this.activeWay == 0) {
      (document as any).getElementById("qrcode").innerHTML = "";
      const res = await QrAlipayGame(obj);
      this.qrCode(res.data.url);
    }
    if (this.activeWay == 1) {
      (document as any).getElementById("qrwxcode").innerHTML = "";
      const res = await QrWechatGame(obj);
      this.qrWxCode(res.data.url);
    }
    this.timer = setTimeout(() => {
      this.qrScan();
    }, 1140000);
  }
  public mounted() {
    this.account = this.lastAccount = JSON.parse(
      JSON.stringify(this.$store.state.user.formInline.account)
    );
    this.judge();
    this.payProps();
  }
  public beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
  // 修改props参数
  public payProps() {
    this.payListData = this.payList;
  }
  // 充值状态判断
  public payGold(index) {
    if (this.active == index) {
      this.active = null;
    } else {
      this.active = index;
    }
    this.payListData.forEach((item, ids) => {
      if (ids == index) {
        this.money = (item as any).money;
      }
    });
  }
  // 支付状态判断
  public paycomWay(index) {
    if (this.activeWay == index) {
      this.activeWay = null;
    } else {
      this.activeWay = index;
    }
  }
  //   支付输入状态
  public moneyKey() {
    this.active = 6;
    this.money = this.moneyChange;
  }
  public qrCode(url: any): void {
    const qrcode = new this.QRCode("qrcode", {
      width: 144, // 图像宽度
      height: 144, // 图像高度
      colorDark: "#000000", // 前景色
      colorLight: "#ffffff", // 背景色
      typeNumber: 4,
    });
    qrcode.clear(); // 清除二维码
    qrcode.makeCode(url); // 生成另一个新的二维码
  }
  public qrWxCode(url: any): void {
    const qrcode = new this.QRCode("qrwxcode", {
      width: 144, // 图像宽度
      height: 144, // 图像高度
      colorDark: "#000000", // 前景色
      colorLight: "#ffffff", // 背景色
      typeNumber: 4,
    });
    qrcode.clear(); // 清除二维码
    qrcode.makeCode(url); // 生成另一个新的二维码
  }
  public clearBlank() {
    // 空格回退
    this.moneyChange = this.moneyChange.replace(/[, ]/g, "");
    // 不允许输入中文
    this.moneyChange = this.moneyChange.replace(/[\u4e00-\u9fa5]/gi, "");
    // 限制字符串
    this.moneyChange = this.moneyChange.replace(/[^\d\.]/g, "");
    // 不允许输入特殊符号
    this.moneyChange = this.moneyChange.replace(/[^\w\u4E00-\u9FA5]/g, "");
  }
  // 用户信息判断
  public async judge() {
    if (this.account != this.lastAccount) {
      clearTimeout(this.timer);
      this.timer = null;
      this.gameList = [];
      this.boxGameId = "";
      this.serverList = [];
      this.serverid = "";
      this.roleList = [];
      this.roleid = null;
      this.activeWay = null;
      this.active = null;
    }
    const obj = {
      token: this.$fn.cookies.getToken("token"),
      account: this.account,
    };
    const res = await CheckUser(obj);
    if (res.code == 200) {
      this.gameChange();
      this.lastAccount = this.account;
    } else {
      this.$Message.error(res.msg);
    }
  }
  // 获取游戏选取列表
  public async gameChange() {
    const obj = {
      token: this.$fn.cookies.getToken("token"),
      uid: this.account,
    };
    const res = await UserGames(obj);
    this.gameList = res.data.game_list;
  }
  // 玩家区服列表
  public async boxGameChange(e) {
    this.boxGameId = e.value;
    const obj = {
      token: this.$fn.cookies.getToken("token"),
      game_id: e.value,
      uid: "",
    };
    const res = await ServerList(obj);
    this.serverList = res.data.server_list;
    this.PayGrade();
  }
  // 游戏充值档位
  public async PayGrade() {
    const obj = {
      token: this.$fn.cookies.getToken("token"),
      game_id: this.boxGameId,
    };
    const res = await PayGrade(obj);
    // debugger;
    this.payListData = res.data.pay_grade;
    if (this.active != null) {
      this.money = this.payList[this.active].money;
    }
  }
  // 选取角色
  public async boxRoleChange(e) {
    this.serverid = e.value;
    const obj = {
      token: this.$fn.cookies.getToken("token"),
      game_id: this.boxGameId,
      server_id: e.value,
    };
    const res = await RoleList(obj);
    this.roleList = res.data.role_list;
  }
}
